import { render, staticRenderFns } from "./review_workplan_empty_state.vue?vue&type=template&id=6147723c"
import script from "./review_workplan_empty_state.vue?vue&type=script&lang=js"
export * from "./review_workplan_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports